import { Link } from '@mui/material';

interface Props {
    isBodyExpanded: boolean;
    bodyExpandedHandler: (val: boolean) => void;
    label?: string;
}

export default function ShowLessButton({
    isBodyExpanded,
    bodyExpandedHandler,
    label = 'View less',
}: Props) {
    return (
        <>
            {isBodyExpanded && (
                <div className="actions">
                    <Link
                        onClick={() => bodyExpandedHandler(false)}
                        sx={{
                            textDecoration: 'none',
                            cursor: 'pointer',
                            marginTop: '8px',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}
                    >
                        {label}
                    </Link>
                </div>
            )}
        </>
    );
}
